import axios from 'axios';

import { localStorageHelper } from '@/utils/helpers';

// import moment from 'moment';

// Axios response interceptor
axios.interceptors.response.use(
  response => {
    // Chek if is login respone
    if (response.data.access_token) {
      return response;
    }

    if (localStorage.getItem('time') === null) {
      localStorage.setItem(
        'time',
        JSON.stringify({
          ttl: response.data.expires_in,
          loginstamp: Date.now(),
        }),
      );
    }

    const timeNowMs = Date.now();
    const localStorageTimeObj = JSON.parse(localStorage.getItem('time'));
    const loginTimeStampMs = localStorageTimeObj.loginstamp;
    const ttlMs = localStorageTimeObj.ttl * 1000;
    let elapsedTimeMs = timeNowMs - loginTimeStampMs;

    /* function msToTime(ms) {
      let seconds = (ms / 1000).toFixed(1);
      let minutes = (ms / (1000 * 60)).toFixed(1);
      let hours = (ms / (1000 * 60 * 60)).toFixed(1);
      let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
      if (seconds < 60) return seconds + ' Sec';
      else if (minutes < 60) return minutes + ' Min';
      else if (hours < 24) return hours + ' Hrs';
      else return days + ' Days';
    } */

    /* console.log(`Token will expire after ${msToTime(ttlMs - elapsedTimeMs)}`);
    console.log(`elapsed Time ${msToTime(elapsedTimeMs)}`); */

    /* console.log(
      `Token will expire after ${Math.floor((ttlMs - elapsedTimeMs) / (24 * 60 * 60 * 1000))} days`,
      `Token will expire after ${ttlMs - (elapsedTimeMs / 60) * 60} h`,
    ); */

    async function refreshToken() {
      return await axios(`${authApiUrl}/auth/refreshtoken`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      });
    }

    if (elapsedTimeMs >= ttlMs) {
      elapsedTimeMs = 0;

      refreshToken()
        .then(response => {
          localStorage.setItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            response.data.access_token,
          );

          localStorage.setItem(
            'time',
            JSON.stringify({
              ttl: response.data.expires_in,
              loginstamp: Date.now(),
            }),
          );

          location.reload();
        })
        .catch(err => {
          throw err;
        });
    }

    return response;
  },
  error => {
    // return error.response;
    return Promise.reject(error);
  },
);

const authApiUrl = process.env.VUE_APP_API_URL;

console.log('url: ', authApiUrl);

const state = {
  /* Authorization */
  token: localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null,
  accountType: localStorage.getItem('acc') || null,
  uuid: localStorage.getItem('uuid') || null,
  expiresIn: /* JSON.parse(localStorage.getItem('time')).ttl * 1000  */ null,
  loginStamp: /* JSON.parse(localStorage.getItem('time')).loginstamp  */ null,
  timeNow: Date.now(),
  /* End Authorization */
  jobId: localStorage.getItem('job_id') || null,
  userProfile: {
    languages: [],
    documents: [],
    competences: [],
    address: [],
    timezone: '',
  },
  notification: null,
  jobAds: [],
  jobAdById: {
    description: '',
    id: '',
    country: { name: '' },
    city: { name: '' },
  },
  jobActivities: [],
  totalPages: 0,
  currentPage: 1,
  nextPage: null,
  pipelines: [],
  dndPipelines: [],
  candidates: [],
  candidateById: {
    activities: [],
    competences: [],
    languages: [],
    source: { description: '', 'source-name': '' },
    photo: 'default.png',
  },
  avatar: '',
  candidateDocuments: [],
  candidateActivities: [],
  candidateEmails: [],
  emailAttachments: [],
  candidatePipelines: [],
  existingCandidates: [],
  employersDropdownData: [],
  employersDropdownDataCandidate: [],
  jobsForEmployer: [],
  jobsForCurrentEmployer: [],
  employersList: [],
  employerById: {
    address: {
      address: '',
      city: '',
      country: '',
      latitude: null,
      longitude: null,
      postal_code: '',
    },
    manager: {
      address: {
        address: '',
        city: '',
        country: '',
        latitude: null,
        longitude: null,
        postal_code: '',
      },
      laguages: [],
    },
    laguages: [],
    competences: [],
  },
  employerAgreement: '',
  employerUsers: '',
  getLogs: [],
  logActions: [],
  allInternalUsers: [],
  usersByEmployer: [],
  allCountries: [],
  citiesByCountryId: [],
  citiesListByCountryId: [],
  locationByName: [],
  competencesFilterList: [],
  languagesList: [],
  addEmployerStatus: {},
  candidateComments: [],
  candidateComment: '',
  jobAdCommentsList: [],

  successMessage: '',
  errorMessage: '',
  isEmailExist: false,
  /* Global Errors */
  globalError: '',
  globalMessage: '',
  /* End Global Errors */
  documentPreview: '',
  downloadedDocument: '',
  documentDeleted: '',
  defaultDocumentError: '',
  sourceList: [],
  reviewJobsList: [],
  reviewApplicationsList: [],
  candidatePipelineRating: '',
  activitiesForJob: [],
  activitiesForEmployer: [],
  employerComments: [],
  employerLogs: [],
  chartOneData: [],
  chartTwoData: [],
  funnelOneData: [],
  funnelTwoData: [],
  recentPlacements: [],
  fakeEmail: '',

  jobAdByIdForCopyExisting: {
    description: '',
    id: '',
    country: { name: '' },
    city: { name: '' },
  },

  guide: {
    show: false,
    step: 1,
  },
};

const getters = {
  /* Authorization */
  /*  getToken: state => state.token, */
  getToken: () => localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null,
  isTokenExpired: state => {
    let elapsed = state.timeNow - state.loginStamp;
    return elapsed > state.expiresIn;
  },
  getAccType: state => state.accountType,
  /* End Authorization */
  getGlobalError: state => state.globalError,
  jobId: state => state.jobId,
  getUserProfile: state => state.userProfile,
  getNotificationMessage: state => state.notification,
  getJobAds: state => state.jobAds,
  getJobAdById: state => state.jobAdById,
  getJobActivities: state => state.jobActivities,
  getNextPage: state => state.nextPage,
  getTotalPages: state => state.totalPages,
  getCurrentPage: state => state.currentPage,
  getPipelines: state => state.pipelines,
  getCandidates: state => state.candidates,
  getCandidateById: state => state.candidateById,
  getCandidateDocuments: state => state.candidateDocuments,
  getCandidateActivities: state => state.candidateActivities,
  getCandidateEmails: state => state.candidateEmails,
  getEmailAttachments: state => state.emailAttachments,
  getCandidatePipelines: state => state.candidatePipelines,
  getRating: state => state.candidatePipelineRating,
  getExistingCandidates: state => state.existingCandidates,
  getEmployersDropdown: state => state.employersDropdownData,
  getEmployersDropdownCandidate: state => state.employersDropdownDataCandidate,
  getJobsForEmployer: state => state.jobsForEmployer,
  getJobsForCurrentEmployer: state => state.jobsForCurrentEmployer,
  getEmployersList: state => state.employersList,
  getEmployerById: state => state.employerById,
  getEmployerUsers: state => state.employerUsers,
  getEmployerLogs: state => state.employerLogs,
  getLogs: state => state.getLogs,
  getLogActions: state => state.logActions,
  getAllInternalUsers: state => state.allInternalUsers,
  getUsersByEmployer: state => state.usersByEmployer,
  getAllCountries: state => state.allCountries,
  getCitiesByCountry: state => state.citiesByCountryId,
  getCitiesListByCountry: state => state.citiesListByCountryId,
  getCitiesByName: state => state.citiesByName,
  getCompetencesFilterList: state => state.competencesFilterList,
  getLanguagesList: state => state.languagesList,
  getCandidateComments: state => state.candidateComments,
  getJobAdCommentsList: state => state.jobAdCommentsList,
  getSuccessMessage: state => state.successMessage,
  getErrorMessage: state => state.errorMessage,
  getIsEmailExist: state => state.isEmailExist,
  getCandidateAvatar: state => state.avatar,
  getDocumentPreview: state => state.documentPreview,
  getdownloadedDocument: state => state.downloadedDocument,
  getSourceList: state => state.sourceList,
  getReviewJobsList: state => state.reviewJobsList,
  getReviewApplicationsList: state => state.reviewApplicationsList,
  getActivitiesForJob: state => state.activitiesForJob,
  getActivitiesForEmployer: state => state.activitiesForEmployer,
  getEmployerComments: state => state.employerComments,
  getChartOneData: state => state.chartOneData,
  getChartTwoData: state => state.chartTwoData,
  getFunnelOneData: state => state.funnelOneData,
  getFunnelTwoData: state => state.funnelTwoData,
  getRecentPlacements: state => state.recentPlacements,
  getFakeEmail: state => state.fakeEmail,
  getGuide: state => state.guide,
};

const actions = {
  /* Authorization */

  completeProfile({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_API_URL}/manager/auth/confirm`, payload)
        .then(response => {
          const { access_token, user_type, expires_in } = response.data;

          const ttlSettings = {
            ttl: expires_in,
            loginstamp: Date.now(),
          };

          localStorage.setItem('time', JSON.stringify(ttlSettings));
          localStorage.setItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`, access_token);
          localStorage.setItem('acc', user_type);

          // Commit the token and account type to the store
          commit('setToken', access_token);
          commit('setAccountType', user_type);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveToken({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/auth/login`, {
        method: 'post',
        data: { ...payload },
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { access_token, user_type, expires_in } = response.data;

          const ttlSettings = {
            ttl: expires_in,
            loginstamp: Date.now(),
          };

          localStorage.setItem('time', JSON.stringify(ttlSettings));
          localStorage.setItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`, access_token);
          localStorage.setItem('acc', user_type);

          // localStorage.setItem('lbUser', JSON.stringify({ type: user_type, token: access_token }));

          commit('setToken', access_token);
          commit('setAccountType', user_type);
          /* commit('setExpiresIn', expires_in); */

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  destroyToken({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/auth/logout`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          localStorageHelper();
          commit('destroyToken');
          resolve(response);
        })
        .catch(err => {
          localStorageHelper();
          commit('destroyToken');
          reject(err);
        });
    });
  },
  changePassword({ /* commit, */ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/auth/changepassword`, {
        method: 'post',
        data: {
          old_password: payload.old_password,
          new_password1: payload.new_password1,
          new_password2: payload.new_password2,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  registerUserId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const {
        firstName,
        lastName,
        email,
        city_id,
        country_id,
        postal,
        password,
        campaign_id,
        campaign_medium,
        campaign_name,
        campaign_source,
        timeZone,
        subscribe,
      } = payload;

      axios(`${authApiUrl}/auth/confirm`, {
        method: 'post',
        data: {
          email: email,
          password: password,
          first_name: firstName,
          last_name: lastName,
          city_id: city_id,
          country_id: country_id,
          postal: postal,
          campaign_id,
          campaign_medium,
          campaign_name,
          campaign_source,
          timezone_id: timeZone.id,
          newsletter_subscription: subscribe,
        },
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { access_token, user_type, expires_in } = response.data;

          const ttlSettings = {
            ttl: expires_in,
            loginstamp: Date.now(),
          };

          localStorage.setItem('time', JSON.stringify(ttlSettings));
          localStorage.setItem(`app_token`, access_token);
          localStorage.setItem('acc', user_type);

          commit('setAccesToken', access_token);
          commit('setUserType', user_type);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  confirmCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { uuid, code } = payload;

      axios(`${authApiUrl}/auth/confirm`, {
        method: 'post',
        data: {
          id: uuid,
          code,
        },
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { access_token, user_type } = response.data;

          localStorage.setItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`, access_token);
          localStorage.setItem('acc', 'candidate');

          commit('setAccesToken', access_token);
          commit('setUserType', user_type);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  confirmCodeEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { uuid, code } = payload;

      axios(`${authApiUrl}/manager/auth/confirm`, {
        method: 'post',
        data: {
          id: uuid,
          code,
        },
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { access_token } = response.data;

          localStorage.setItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`, access_token);
          localStorage.setItem('acc', 'manager');

          commit('setAccesToken', access_token);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Authorization */
  retrieveUserProfile({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/profile`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setUserProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveUserProfileMarketing({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/marketing/profile/get`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setUserProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateUserProfile({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/profile`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setUserProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editUserProfile({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const {
        first_name,
        last_name,
        email2,
        email3,
        phone,
        skype,
        street,
        postal,
        city,
        country,
        linkedin,
        webpage,
        competences,
        languages,
        format_date,
      } = payload;

      axios(`${authApiUrl}/profile/update`, {
        method: 'post',
        data: {
          first_name,
          last_name,
          email2,
          email3,
          phone,
          skype,
          street,
          postal,
          city,
          country,
          linkedin,
          webpage,
          competences,
          languages,
          format_date,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { statusText } = response.data;

          // Code success state
          commit('setUserProfile', payload);
          commit('setNotificationMessage', statusText);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editUserCandidateProfile({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const {
        first_name,
        last_name,
        email2,
        email3,
        phone,
        skype,
        street,
        postal,
        city,
        country,
        linkedin,
        webpage,
        competences,
        languages,
        format_date,
      } = payload;

      axios(`${authApiUrl}/candidate/update`, {
        method: 'post',
        data: {
          first_name,
          last_name,
          email2,
          email3,
          phone,
          skype,
          street,
          postal,
          city,
          country,
          linkedin,
          webpage,
          competences,
          languages,
          format_date,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { statusText } = response.data;

          // Code success state
          commit('setUserProfile', payload);
          commit('setNotificationMessage', statusText);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  connectEmail({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/settings/connectemail`, {
        method: 'post',
        data: {
          email: payload.email,
          password: payload.password,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* Jobs */
  AddJobAd({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/create`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateJobAdById({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* copyExistingJobAd({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/duplicate`, {
        method: 'post',
        data: {
          js_employer_jobad_id: payload.js_employer_jobad_id,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }, */
  retrieveJobAds({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/search`, {
        method: 'post',
        data: {
          search_word: payload.search_word || '',
          page: Number(payload.page),
          count: payload.count,
          published: payload.published,
          promoted: payload.promoted,
          employers: payload.employersList || [],
          service_level: payload.service_level,
          filters: payload.filters,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;
          const totalPages = last_page;

          commit('setJobAds', data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(totalPages));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveJobAdById({ commit, state }, jobAdUuid) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/index/${jobAdUuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setJobAdById', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveJobAdByIdForCopyExisting({ state }, jobAdUuid) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/index/${jobAdUuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setJobStatus({ commit }, payload) {
    axios(`${authApiUrl}/admin/jobad/status`, {
      method: 'post',
      data: {
        js_employer_jobad_id: payload.js_employer_jobad_id,
        status: payload.status,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
        Accept: 'application/json',
      },
    })
      .then(response => {
        commit('setNewJobStatus', response.data);
      })
      .catch(err => {
        throw err;
      });
  },
  retrieveJobActivities({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/activities/${payload.jobad_id}`, {
        method: 'get',
        params: {
          jobad_id: payload.jobad_id,
          page: payload.page,
          count: payload.count,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setJobActivities', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* PIPELINES */
  updateDndPipelines({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/updatestage`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          stage: payload.stage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* END PIPELINES */

  /*   retrievePipelines({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/forjob/${payload.id}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setDnDPipelines', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }, */

  /* Pipelines for job */
  retrieveJobsPipeline({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/paginatedforjob`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;

          commit('setPipelines', data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(last_page));
          commit('setCurrentPage', Number(current_page));
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveExistingCandidates({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidate/searchbynameoremail`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(({ data }) => {
          commit('setExistingCandidates', data);
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addExistingCandidate({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/add-existing`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveDndPipelines({ commit }, payload) {
    if (typeof payload.id === 'undefined') {
      return false;
    } else {
      return new Promise((resolve, reject) => {
        axios(`${authApiUrl}/admin/pipeline/forjob/${payload.id}`, {
          method: 'get',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(response => {
            commit('setDndPipelines', response.data);
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  /* Candidates */
  retrieveCandidates({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidate/search`, {
        method: 'post',
        data: {
          search_word: payload.search_word || '',
          page: Number(payload.page),
          count: payload.count,
          filters: payload.filters,
          employers: payload.employersList || [],
          sources: payload.sourcesList || [],
          opted_out: payload.optedOut,
          freelancers: payload.freelancers,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { current_page, last_page /* total */ } = response.data;
          const candidates = response.data.data;
          const totalPages = last_page;

          commit('setCandidates', candidates);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', Number(totalPages));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateById({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidate/index/${payload.uuid}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const candidate = response.data;
          const candidateDocuments = response.data.documents;

          commit('setCandidateById', candidate);
          commit('setCandidateDocuments', candidateDocuments);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateActivities({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/activity/forcandidate/`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          params: {
            ...payload,
          },
        })
        .then(response => {
          commit('setCandidateActivities', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateAvatar({ commit, state }, { uuid }) {
    return new Promise((reslove, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidate/avatar/${uuid}`, {
          responseType: `blob`,
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'image/*' });
          const fileUrl = URL.createObjectURL(blob);

          commit('setCandidateAvatar', fileUrl);
          reslove(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editCandidateById({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidate/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addCandidate({ state }, payload) {
    return new Promise((resolve, reject) => {
      const { file } = payload;

      for (const [key, value] of Object.entries(payload)) {
        if (key == 'competences' || key == 'languages') {
          Object.values(value).forEach(val => {
            file.append(`${key}[]`, val);
          });
        } else if (key == 'email') {
          file.append(key, value);
        } else {
          file.append(key, value);
        }
      }

      /*  for (const key of file.keys()) {
        console.log(key, file.get(key));
      } */

      axios
        .post(`${authApiUrl}/admin/candidate/create`, file, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteCandidate({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidate/delete/${payload.candidate_id}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  candidateUpladAvatar({ state }, { formData }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${authApiUrl}/admin/candidate/uploadavatar`, formData, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'multipart/form-data',
            'Cache-Control': 'no-cache',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  candidateDeleteAvatar({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${authApiUrl}/admin/candidate/deleteavatar/${payload.candidate_id}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateEmails({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/email/forcandidate/${payload.candidateId}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const candidateEmails = response.data;
          commit('setCandidateEmails', candidateEmails);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* /admin/emailattachments/preview/62f13d66-8fc6-4b81-a0e7-e246cfa3e443 */
  retrieveEmailAttachments({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/emailattachments/preview/${payload.attachmentId}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const emailAttachments = response.data;
          commit('setEmailAttachments', emailAttachments);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveActivitiesForJob({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/activity/forjob/`, {
          params: {
            jobad_id: payload.jobad_id,
            page: payload.page,
            count: payload.count,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setActivitiesForJob', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addActivity({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/activity/create`, {
        method: 'post',
        data: {
          jobad_id: payload.job_id,
          candidate_id: payload.candidate_id,
          comment: payload.comment,
          stage: payload.stage,
          qualification: payload.qualification,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeActivity({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/activity/delete/${payload.activityID}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateActivity({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/activity/update`, {
        method: 'post',
        data: {
          activity_id: payload.activity_id,
          comment: payload.activity_comment,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateComments({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidatecomments/list/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setCandidateComments', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addCandidateComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidatecomments/create`, {
        method: 'post',
        data: {
          candidate_id: payload.uuid,
          data: payload.message,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidatecomments/update`, {
        method: 'post',
        data: {
          comment_id: payload.uuid,
          data: payload.data,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeCandidateComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidatecomments/delete/${payload.uuid}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* End Candidates */

  /* Employers */
  retrieveEmployersList({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/search`, {
        method: 'post',
        data: {
          search_word: payload.search_word,
          page: Number(payload.page),
          count: payload.count,
          agreement_level: payload.agreement_level,
          filters: payload.filters || [],
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { last_page, current_page } = response.data;

          const employersList = response.data.data;
          const totalPages = last_page;

          commit('setEmployersList', employersList);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', totalPages);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveEmployerById({ commit, state }, employerId) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/index/${employerId}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployerById', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateEmployerById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployerById', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/create`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('AddEmployer', response.status);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveUsersByEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/usersbyemployer/${payload.employerId}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const users = response.data.result;

          commit('setUsersByEmployer', users);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setEmployerAgreement({ commit, dispatch }, payload) {
    axios(`${authApiUrl}/admin/employer/agreement`, {
      method: 'post',
      data: {
        ...payload,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
        Accept: 'application/json',
      },
    })
      .then(response => {
        dispatch('retrieveEmployerById', payload.js_employer_id);
      })
      .catch(err => {
        throw err;
      });
  },
  retrieveEmployerComments({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employercomments/list/${payload.js_employer_id}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployerComments', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveEmployerLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/logs/employerlogs`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployerLogs', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addEmployerComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employercomments/create`, {
        method: 'post',
        data: {
          js_employer_id: payload.js_employer_id,
          data: payload.message,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editEmployerComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employercomments/update`, {
        method: 'post',
        data: {
          comment_id: payload.comment_id,
          data: payload.data,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeEmployerComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employercomments/delete/${payload.comment_id}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateUserForEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/updateuserforemployer`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('updateUserForEmployer', response.status);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveActivitiesForEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/activity/foremployer/`, {
          params: {
            ...payload,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setActivitiesForEmployer', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Employers */

  /* Admin Logs */
  retrieveLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/logs/systemlogs`, {
          params: {
            ...payload,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;

          commit('setLogs', data);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', Number(last_page));
          commit('setNextPage', next_page_url);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveAllInternalUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/logs/allinternalusers`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const allInternalUsers = response.data.result;

          commit('setAllInternalUsers', allInternalUsers);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveLogActions({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/logs/listallactions`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const logActions = response.data;

          commit('setlogActions', logActions);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  searchCandidateLogs({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/logs/searchcandidates/${payload.search}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            Accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* LinkedInProvider({ commit }, payload) {
    const apiRedirect = () =>
      window.open(
        `https://jobshark.eu/linkedin/redirect`,
        '_self',
        '_blank',
        'Login with LinkedIn',
      );

    if (payload.from === 'apply-with-linkedin') {
      localStorage.setItem('job_id', payload.jobId);
      commit('setJobId', payload.jobId);
      apiRedirect();
    } else if (payload.from === 'login') {
      apiRedirect();
    } else if (payload.from === 'register') {
      localStorage.setItem('linkedinRegister', 1);
      apiRedirect();
    }
  }, */
  notificationMessage({ commit }, payload) {
    commit('setNotificationMessage', payload.message);
  },
  /* Admin Users */
  retrieveEmployerUsers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/usersforemployer/${payload.js_employer_id}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployerUsers', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* JobAd Comments */
  retrieveJobComments({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jsemployersjobadcomments/list/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          let comments = response.data;

          commit('setJobAdComments', comments);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addJobAdComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jsemployersjobadcomments/create`, {
        method: 'post',
        data: {
          js_employer_jobad_id: payload.uuid,
          data: payload.message,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editJobAdComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jsemployersjobadcomments/update`, {
        method: 'post',
        data: {
          comment_id: payload.uuid,
          data: payload.data,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeJobAdComment(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jsemployersjobadcomments/delete/${payload.uuid}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End JobAd Comments */

  /* Check if email already exist */
  checkIfEmailExist({ commit }, email) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/auth/emailexists/${email}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmailExist', true);

          resolve(response);
        })
        .catch(err => {
          commit('setEmailExist', false);

          reject(err);
        });
    });
  },
  retrieveFakeEmail({ commit }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/candidate/getfakeemail`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setFakeEmail', response.data[0]);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* Common */
  retrieveEmployersDropdown({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/dropdown`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setEmployersDropdown', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveEmployersDropdownCandidate({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/candidate/employersdropdown`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const employersDropdownDataCandidate = response.data;

          commit('setEmployersDropdownCandidate', employersDropdownDataCandidate);
          resolve(response);
        })
        .catch(err => {
          reject(err.response.status);
        });
    });
  },

  retrieveJobsForEmployerDropdown({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/jobsfordashboards/${payload.employerId}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const employersDropdownData = response.data;

          /*  const { last_page, current_page } = response.data;
          const totalPages = last_page;

          commit('setCurrentPage', current_page);
          commit('setTotalPages', totalPages); */
          commit('setJobsForEmployer', employersDropdownData);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveJobsForEmployer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/employer/jobsforemployer`, {
        method: 'post',
        data: {
          js_employer_id: payload.employerId,
          search_word: payload.search_word,
          service_level: payload.service_level,
          published: payload.published,
          page: payload.page,
          count: payload.count,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { last_page, current_page } = response.data;
          const totalPages = last_page;

          commit('setJobsForCurrentEmployer', response.data);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', totalPages);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveAllCountries({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/address/countries`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setAllCountries', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCityByCountryId({ commit }, cityId) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/cities/bycountry/${cityId}`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const citiesByCountryId = response.data;

          commit('setCitiesByCountryId', citiesByCountryId);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCityByPostalAndCoutryId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/address/action`, {
        method: 'post',
        data: {
          postalcode: payload.postalcode,
          country_id: payload.country_id,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit();
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCitiesListByCountryId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/address/citiesbycountryid/${payload.id}`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const citiesListByCountryId = response.data;

          commit('setCitiesListByCountryId', citiesListByCountryId);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  searchLocationByName({ commit }, location) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/address/searchlocation/${location}`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const locationByName = response.data;

          commit('setLocationByName', locationByName);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCompetencesList({ commit }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/competence/flatlist`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const competencesList = response.data;

          commit('setCompetencesList', competencesList);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveLanguagesList({ commit }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/common/language/languages`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const languagesList = response.data;

          commit('setLanguagesList', languagesList);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updatePipelineForCandidate({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/updateforcandidate`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          stage: payload.stage,
          qualification: payload.qualification,
          source_id: payload.source_id,
          documents: payload.documents,
          activity_comment: payload.activity_comment,
          programming_test: payload.programming_test,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  submitCandidatePipeline({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/submitcandidate`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          submitted_comment: payload.submitted_comment,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Common */

  /* Sources */
  retrieveSourcesList({ commit }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/source/list`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setSourceList', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createSource({ state }, { description, source }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/source/create`, {
        method: 'post',
        data: {
          description,
          source,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeSource({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/source/delete/${payload.uuid}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateSource({ state }, { id, source, description }) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/source/update`, {
        method: 'post',
        data: {
          id,
          source,
          description,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Sources */

  /* Candidate */
  retrieveCandidateDocuments({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidate/documents`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setCandidateDocuments', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateUserDocuments({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/documents`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setCandidateDocuments', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateDocument({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidatedocuments/preview/${payload.uuid}`, {
          params: {
            preview: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveDocumentPreview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidatedocuments/preview/${payload.uuid}`, {
          params: {
            preview: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentPreview', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCandidateDocumentPreview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/documents/preview/${payload.uuid}`, {
          params: {
            preview: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentPreview', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveEmployerDocumentPreview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/employer/previewdocagreement/${payload.uuid}`, {
          params: {
            document_id: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentPreview', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveFreelancerDocumentPreview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/getagreement`, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentPreview', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveFreelancerDocumentPreviewAdmin({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/freelancer/getagreement/${payload.uuid}`, {
          params: {
            preview: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidatedocuments/delete/${payload.uuid}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentDeleted', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteCandidateDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/documents/delete/${payload.uuid}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDocumentDeleted', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  downloadDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidate/documents/${payload.uuid}`, {
          headers: {
            responseType: 'blob',
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setDownloadedDocument', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setDefaultDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/admin/candidatedocuments/makecv/${payload.uuid}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          commit('setDefaultDocumentError', err);
          reject(err);
        });
    });
  },
  setDefaultCandidateDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/candidate/documents/cv/${payload.uuid}`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          commit('setDefaultDocumentError', err);
          reject(err);
        });
    });
  },

  /*  retrieveJobsPipeline({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/paginatedforjob`, {
        method: 'post',
        data: {
          js_employer_jobad_id: payload.js_employer_jobad_id,
          search_word: payload.search_word,
          page: payload.page,
          count: payload.count,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;
          const totalPages = last_page;

          commit('setPipelines', data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(totalPages));
          commit('setCurrentPage', Number(current_page));
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }, */
  retrieveCandidatePipelines({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/forcandidate`, {
        method: 'post',
        data: {
          candidate_id: payload.candidate_id,
          search_word: payload.search_word,
          page: payload.page,
          count: payload.count,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;

          commit('setCandidatePipelines', data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(last_page));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  submitCandidateToPipeline({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/addforcandidate`, {
        method: 'post',
        data: {
          candidate_id: payload.candidate_id,
          js_employer_id: payload.js_employer_id,
          js_employer_jobad_id: payload.js_employer_jobad_id,
          source_id: payload.source_id,
          activity_comment: payload.activity_comment,
          qualification: payload.qualification,
          documents: payload.documents,
          programming_test: payload.programming_test,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setCandidatePipelineRating({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/updaterating`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          rating: payload.rating,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setRatingForCandidate', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  setCandidateManagerPipelineRating({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/pipelines/updaterating`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          employer_rating: payload.rating,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setRatingForCandidate', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* TODO: Delete Request */
  /*  updateCandidatePipeline({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/updateforcandidate`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          stage: payload.stage,
          qualification: payload.qualification,
          source_id: payload.source_id,
          documents: payload.documents,
          comment: payload.comment,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
        
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }, */
  removeCandidateFromPipeline({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/delete/${payload.pipeline_id}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Candidate */

  /* Review Job */
  retrieveReviewJobs({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/review/jobads`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { current_page, last_page } = response.data;
          const jobs = response.data.data;
          const totalPages = last_page;

          commit('setReviewJobs', jobs);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', Number(totalPages));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  approveReviewJob({ state }, payload) {
    const { js_employer_jobad_id } = payload;

    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/review/jobadaccept`, {
        method: 'post',
        data: {
          js_employer_jobad_id,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  rejectReviewJob({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/review/jobadreject`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* End Review Job */

  /* Review Applications */
  retrieveReviewApplications({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/review/applications`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { current_page, last_page } = response.data;
          const totalPages = last_page;

          commit('setReviewApplications', response.data.data);
          commit('setCurrentPage', current_page);
          commit('setTotalPages', Number(totalPages));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeReviewApplication(_, pipelineID) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/pipeline/delete/${pipelineID}`, {
        method: 'delete',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Review Applications */

  /* DASHBOARD */
  retrieveJobsForEmployerChart(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/jobad/jobsfordashboards`, {
        method: 'get',
        params: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveCharOnetData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/dashboard/admintoplinechart`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setChartOneData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveChartTwoData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/dashboard/adminmiddlelinechart`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setChartTwoData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveFunnelOneData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/dashboard/employerfunnel`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setFunnelOneData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveFunnelTwoData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/dashboard/adminsourcefunnel`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setFunnelTwoData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveRecentPlacements({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/admin/dashboard/recentplacements`, {
        method: 'get',
        params: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { next_page_url, current_page, last_page } = response.data;

          commit('setRecentPlacements', response.data.data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(last_page));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  setCandidateGuideStep({ commit }, newStep) {
    commit('SET_GUIDE_STEP', newStep);
  },

  /* END DASHBOARD */
};

const mutations = {
  /* Authorization */
  setAccesToken: (state, accesToken) => (state.token = accesToken),
  setUserType: (state, userType) => (state.accountType = userType),
  retrieveUuid: (state, uuid) => (state.uuid = uuid),
  setToken: (state, token) => (state.token = token),
  setExpiresIn: (state, expiresIn) => (state.expiresIn = expiresIn),
  setAccountType: (state, user_type) => (state.accountType = user_type),
  destroyToken: state => {
    state.accountType = null;
    state.token = null;
  },
  setUuid: (state, uuid) => (state.uuid = uuid),
  /* End Authorization */
  setUserProfile: (state, profile) => (state.userProfile = profile),
  setNotificationMessage: (state, message) => (state.notification = message),
  setJobAds: (state, jobAds) => (state.jobAds = jobAds),
  setJobAdById: (state, jobAdById) => (state.jobAdById = jobAdById),
  setNewJobStatus: (state, newJobStatus) => (state.newJobStatus = newJobStatus),
  setNextPage: (state, nextPage) => (state.nextPage = nextPage),
  setTotalPages: (state, totalPages) => (state.totalPages = totalPages),
  setCurrentPage: (state, currentPage) => (state.currentPage = currentPage),
  setJobActivities: (state, jobActivities) => (state.jobActivities = jobActivities),
  setCandidateEmails: (state, candidateEmails) => (state.candidateEmails = candidateEmails),
  setEmailAttachments: (state, emailAttachments) => (state.emailAttachments = emailAttachments),
  setPipelines: (state, pipelines) => (state.pipelines = pipelines),
  setDndPipelines: (state, dndPipelines) => (state.dndPipelines = dndPipelines),
  setCandidates: (state, candidates) => (state.candidates = candidates),
  setCandidateById: (state, candidate) => (state.candidateById = candidate),
  setCandidateActivities: (state, activities) => (state.candidateActivities = activities),
  setCandidateDocuments: (state, candidateDocuments) =>
    (state.candidateDocuments = candidateDocuments),
  setCandidateAvatar: (state, avatar) => (state.avatar = avatar),
  setCandidatePipelines: (state, pipelines) => (state.candidatePipelines = pipelines),
  setRatingForCandidate: (state, rating) => (state.candidatePipelineRating = rating),
  setExistingCandidates: (state, existingCandidates) => {
    const newExistingCandidates = existingCandidates.map(exCandidate => {
      return { ...exCandidate, name: `${exCandidate.first_name} ${exCandidate.last_name}` };
    });

    state.existingCandidates = newExistingCandidates;
  },
  setEmployersDropdown: (state, employersDropdownData) =>
    (state.employersDropdownData = employersDropdownData),
  setEmployersDropdownCandidate: (state, employersDropdownDataCandidate) =>
    (state.employersDropdownDataCandidate = employersDropdownDataCandidate),
  setJobsForEmployer: (state, employersDropdownData) =>
    (state.jobsForEmployer = employersDropdownData),
  setJobsForCurrentEmployer: (state, jobsForCurrentEmployer) =>
    (state.jobsForCurrentEmployer = jobsForCurrentEmployer),

  setEmployerComments: (state, employerComments) => (state.employerComments = employerComments),
  setEmployerLogs: (state, employerLogs) => (state.employerLogs = employerLogs),
  setLogs: (state, logs) => (state.getLogs = logs),
  setAllInternalUsers: (state, allInternalUsers) => (state.allInternalUsers = allInternalUsers),
  setUsersByEmployer: (state, users) => (state.usersByEmployer = users),
  setlogActions: (state, logActions) => (state.logActions = logActions),
  setJobId: (state, jobId) => (state.jobId = jobId),
  setAllCountries: (state, allCountries) => (state.allCountries = allCountries),
  setCitiesByCountryId: (state, citiesByCountryId) => (state.citiesByCountryId = citiesByCountryId),
  setCitiesListByCountryId: (state, citiesListByCountryId) =>
    (state.citiesListByCountryId = citiesListByCountryId),
  setLocationByName: (state, locationByName) => (state.locationByName = locationByName),

  setCompetencesList: (state, competencesList) => {
    const normalizedCompetenceList = competencesList.map(c => {
      if (c.hasOwnProperty('candidate_id')) {
        return { ...c, id: c.candidate_id };
      }

      return { ...c, id: c.id };
    });

    state.competencesFilterList = normalizedCompetenceList;
  },
  setLanguagesList: (state, languagesList) => (state.languagesList = languagesList),
  setEmployersList: (state, employersList) => (state.employersList = employersList),
  setEmployerById: (state, employer) => (state.employerById = employer),

  setAddEmployer: (state, status) => (state.addEmployerStatus = status),
  setNewEmployerAgreement: (state, employerAgreement) =>
    (state.employerAgreement = employerAgreement),
  setEmployerUsers: (state, users) => (state.employerUsers = users),
  setCandidateComments: (state, candidateComments) => (state.candidateComments = candidateComments),
  addCandidateComment: (state, candidateComment) => (state.candidateComment = candidateComment),
  setJobAdComments: (state, comments) => (state.jobAdCommentsList = comments),
  setSuccessMessage: (state, statusText) => (state.successMessage = statusText),
  setErrorMessage: (state, errorMessage) => (state.errorMessage = errorMessage),
  setEmailExist: (state, _isEmailExist) => (state.isEmailExist = _isEmailExist),
  setFakeEmail: (state, fakeEmail) => (state.fakeEmail = fakeEmail),
  setGlobalError: (state, error) => (state.globalError = error),
  setGlobalMessage: (state, message) => (state.globalMessage = message),
  setDocumentPreview: (state, documentPreview) => (state.documentPreview = documentPreview),
  setDownloadedDocument: (state, downloadedDocument) =>
    (state.downloadedDocument = downloadedDocument),
  setDocumentDeleted: (state, documentDeleted) => (state.documentDeleted = documentDeleted),
  setDefaultDocumentError: (state, defaultDocumentError) =>
    (state.setDefaultDocumentError = defaultDocumentError),
  setSourceList: (state, sourceList) => (state.sourceList = sourceList),
  setReviewJobs: (state, reviewJobsList) => (state.reviewJobsList = reviewJobsList),
  setReviewApplications: (state, reviewApplicationsList) =>
    (state.reviewApplicationsList = reviewApplicationsList),
  setActivitiesForJob: (state, activitiesForJob) => (state.activitiesForJob = activitiesForJob),
  setActivitiesForEmployer: (state, activitiesForEmployer) =>
    (state.activitiesForEmployer = activitiesForEmployer),
  /* Dashboards */
  setChartOneData: (state, data) => (state.chartOneData = data),
  setFunnelOneData: (state, data) => (state.funnelOneData = data),
  setFunnelTwoData: (state, data) => (state.funnelTwoData = data),
  setChartTwoData: (state, data) => (state.chartTwoData = data),
  setRecentPlacements: (state, data) => (state.recentPlacements = data),
  /* End Dashboarde */

  SET_GUIDE_STEP(state, newStep) {
    state.guide.step = newStep;
  },
  SET_GUIDE_SHOW(state, showValue) {
    state.guide.show = showValue;
  },
};

export default {
  /* namespaced: true, */
  state,
  getters,
  actions,
  mutations,
};
